import React, { useContext } from 'react';

import { MicroOff } from '@yandex-360/iconostasis/dist/icons/MicroOff';

import Button from '../../../../../../shared/components/button';
import { ToolbarContext } from '../../index';
import { MicrophoneButtonProps } from '../types';

export const MutedMicrophoneButton: React.FC<MicrophoneButtonProps> = ({
    onClick,
    title,
    disabled,
    buttonProps,
    testId,
}) => {
    const { buttonSize } = useContext(ToolbarContext);

    return (
        <Button
            title={title}
            view="neutral"
            size={buttonSize}
            onClick={onClick}
            isDisabled={disabled}
            testId={testId}
            icon={<MicroOff variant="solid" size="md" />}
            {...buttonProps}
        />
    );
};
